import React, { useMemo } from 'react';
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  MenuItem,
  IconButton,
} from '@mui/material';
import { red, blue } from '@mui/material/colors';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import countryList from 'react-select-country-list';

export default function UserInfoForm(props) {
  const countries = useMemo(() => countryList().getData(), []);
  const { state, onChange, error } = props;

  return (
    <React.Fragment>
      <Typography variant='h5' mb={3}>
        Your Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id='firstName'
            name='firstName'
            label='First Name'
            fullWidth
            autoComplete='first-name'
            variant='outlined'
            value={state.firstName}
            error={error.firstName}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id='lastName'
            name='lastName'
            label='Last Name'
            fullWidth
            autoComplete='last-name'
            variant='outlined'
            value={state.lastName}
            error={error.lastName}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id='company'
            name='company'
            label='Company'
            fullWidth
            autoComplete='company'
            variant='outlined'
            value={state.company}
            error={error.company}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id='email'
            name='email'
            label='Email'
            fullWidth
            autoComplete='email'
            variant='outlined'
            value={state.email}
            error={error.email}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            required
            id='streetAddress'
            name='streetAddress'
            label='Street Address'
            fullWidth
            autoComplete='street-address'
            variant='outlined'
            value={state.streetAddress}
            error={error.streetAddress}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id='state'
            name='state'
            label='State'
            fullWidth
            autoComplete='state'
            variant='outlined'
            value={state.state}
            error={error.state}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id='city'
            name='city'
            label='City'
            fullWidth
            autoComplete='city'
            variant='outlined'
            value={state.city}
            error={error.city}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id='zip'
            name='zip'
            label='Zip/Postal Code'
            fullWidth
            autoComplete='zip'
            variant='outlined'
            value={state.zip}
            error={error.zip}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            select
            id='country'
            name='country'
            label='Country'
            fullWidth
            autoComplete='country'
            variant='outlined'
            value={state.country}
            error={error.country}
            onChange={(event) =>
              onChange(event.target.name, event.target.value, 1)
            }
          >
            {countries.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        {/* <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                id='checkBill'
                name='checkBill'
                checked={state.checkBill}
                onChange={(event) =>
                  onChange(event.target.name, !state.checkBill, 1)
                }
              />
            }
            label='Billing Address, If not the same as above'
            sx={{ pb: 2 }}
          />
        </Grid> */}
      </Grid>
    </React.Fragment>
  );
}
